import './i18n/autoTranslate';
// src/components/SEO.jsx
import { Helmet } from 'react-helmet-async';
export default function SEO({
    title = 'InterviewGenieAI — AI Interview Practice with Real-Time Feedback',
    description = 'Practice realistic AI interviews, get instant feedback, improve your answers, and track your progress with InterviewGenieAI.',
    canonical = 'https://interviewgenieai.com/',
    image = 'https://interviewgenieai.com/og-image.png',
    noindex = false
  }) {
    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
  
        {noindex ? (
          <meta name="robots" content="noindex, nofollow" />
        ) : (
          <meta name="robots" content="index, follow, max-image-preview:large" />
        )}
  
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={image} />
  
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
      </Helmet>
    );
  }
